export default {
  computed: {
    demoNoteError() {
      const field = this.$v.demoNote;
      if (!field.$dirty) return '';
      if (!field.required) return 'Subject field is mandatory';
      return '';
    },
  },
};
